/* eslint-disable */

import React from "react";
import {
  MdOutgoingMail,
  MdOutlineCancel,
  MdOutlineHowToReg,
} from "react-icons/md";
import { BiBarChartAlt2 } from "react-icons/bi";
import { Button } from "..";
import { userProfileData } from "../../data/menu";
import { useStateContext } from "../../contexts/ContextProvider";
import {
  useUserAccessLevel,
  useUserData,
  useUserLoggedin,
  useUserProfilePic,
} from "../../state/state";
import { Link, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { FaUserAlt, FaUserPlus } from "react-icons/fa";
import { getAccountTypeLabel, isPartnerRole } from "../../utils/roleUtils";

const UserProfile = () => {
  const clientId =
    "372673946018-lu1u3llu6tqi6hmv8m2226ri9qev8bb8.apps.googleusercontent.com";
  const setUserLoggedIn = useUserLoggedin((state) => state.setUserLoggedIn);
  const accessLevel = useUserAccessLevel((state) => state.accessLevel);
  const setAccessLevel = useUserAccessLevel((state) => state.setAccessLevel);
  const { currentColor } = useStateContext();
  const userData = useUserData((state) => state.userData);
  const setUserData = useUserData((state) => state.setUserData);
  const navigate = useNavigate();
  const logOutBtn = useRef(null);
  const dismissProfileBtn = useRef(null);
  const { setIsClicked, initialState, closeDropdown } = useStateContext();
  const userProfilePic = useUserProfilePic((state) => state.userProfilePic);

  const onLogoutSuccess = (res) => {
    localStorage.clear();
    navigate("/");
  };

  const handleLogOut = () => {
    setIsClicked(initialState);
    setUserData(null);
    localStorage.clear();
    navigate("/");
    setUserLoggedIn("");
    setAccessLevel("");
  };

  const handleLogOutClick = () => {
    dismissProfileBtn.current.click();
  };

  return (
    <div className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96 z-50">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">User Profile</p>
        <Button
          icon={<MdOutlineCancel />}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
          onClick={() => closeDropdown("userProfile")}
        />
      </div>
      <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
        <img
          className="rounded-full h-24 w-24"
          src={userProfilePic}
          alt="user-profile"
        />
        <div>
          <p className="font-semibold text-xl dark:text-gray-200">
            {" "}
            {localStorage.getItem("userFirstName")}{" "}
          </p>
          <p className="text-gray-500 text-sm dark:text-gray-400">
            {" "}
            {getAccountTypeLabel(localStorage.getItem("userRole"))}{" "}
          </p>
          <p className="text-gray-500 text-sm font-semibold dark:text-gray-400">
            {" "}
            {localStorage.getItem("userRegEmail")}{" "}
          </p>
        </div>
      </div>
      <div>
        {/* Show dashboard navigation only for partner users */}
        {isPartnerRole(localStorage.getItem("userRole")) && (
          <div
            className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]"
            onClick={() => {
              closeDropdown("userProfile");
              navigate("/dashboard");
            }}
          >
            <button
              type="button"
              style={{ color: "#03C9D7", backgroundColor: "#E5FAFB" }}
              className=" text-xl rounded-lg p-3 hover:bg-light-gray"
            >
              <BiBarChartAlt2 />
            </button>

            <div>
              <p className="font-semibold dark:text-gray-200 ">
                {"Dashboard"}
              </p>
              <p className="text-gray-500 text-sm dark:text-gray-400">
                {" "}
                {"PayIn & PayOut"}{" "}
              </p>
            </div>
          </div>
        )}
        
        {/* Show profile settings only for partner users */}
        {isPartnerRole(localStorage.getItem("userRole")) && (
          <div
            className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]"
            onClick={() => {
              closeDropdown("userProfile");
              navigate("/settings");
            }}
          >
            <button
              type="button"
              style={{ color: "#03C9D7", backgroundColor: "#E5FAFB" }}
              className=" text-xl rounded-lg p-3 hover:bg-light-gray"
            >
              <FaUserAlt />
            </button>

            <div>
              <p className="font-semibold dark:text-gray-200 ">
                {"My Profile"}
              </p>
              <p className="text-gray-500 text-sm dark:text-gray-400">
                {" "}
                {"Account Settings"}{" "}
              </p>
            </div>
          </div>
        )}
        {/* <div
          className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]"
          onClick={() => {
            setIsClicked(initialState);
            navigate("/analytics");
          }}
        >
          <button
            type="button"
            style={{ color: "#03C9D7", backgroundColor: "#E5FAFB" }}
            className=" text-xl rounded-lg p-3 hover:bg-light-gray"
          >
            <BiBarChartAlt2 />
          </button>

          <div>
            <p className="font-semibold dark:text-gray-200 ">{"Analytics"}</p>
            <p className="text-gray-500 text-sm dark:text-gray-400">
              {" "}
              {"Business Intelligence Dashboard"}{" "}
            </p>
          </div>
        </div> */}

        <a
          className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]"
          onClick={() => {
            closeDropdown("userProfile");
          }}
          href="mailto:support@aitubemonetizer.com"
        >
          <button
            type="button"
            style={{ color: "#03C9D7", backgroundColor: "#E5FAFB" }}
            className=" text-xl rounded-lg p-3 hover:bg-light-gray"
          >
            <MdOutgoingMail />
          </button>

          <div>
            <p className="font-semibold dark:text-gray-200 ">{"Support"}</p>
            <p className="text-gray-500 text-sm dark:text-gray-400">
              {" "}
              {"support@nip.ext.netpluspay.com"}{" "}
            </p>
          </div>
        </a>
      </div>
      <div className="mt-5">
        <div id="signoutButton">
        </div>
        <button
          className="w-full rounded-md py-3 text-white"
          style={{ backgroundColor: "#7352FF" }}
          onClick={() => {
            closeDropdown("userProfile");
            handleLogOut();
          }}
          ref={logOutBtn}
        >
          Log Out
        </button>
      </div>
    </div>
  );
};

export default UserProfile;
